import React, { Component } from 'react'
import './ProductCoupleCombo.css';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { coupleComboData, doProductCoupleComboDataRes } from '../../../action/ProductCoupleComboDataAction';
import { cartToAddCombo, doAddToCartComboRes } from '../../../action/AddToCartComboAction';
import { cartListView, doCartListRes } from '../../../action/CartListAction';
import { login_list, doLoginRes } from '../../../action/LoginAction';
import { createRegister, doRegisterRes } from '../../../action/RegisterAction';
import { productVariable, doVariableProductDetailsRes } from '../../../action/VariableProductDetailsAction';
import Footer from '../../../component/Footer/Footer';
import LayoutWrapper from '../../../component/LayoutWrapper/';
// import Swal from 'sweetalert2'
import { Link } from 'react-router-dom';
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import LoginRegister from '../../LoginRegister/LoginRegister'
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import loaderImg from '../../../assets/images/loader-example.gif';
import Loader from 'react-loader-advanced';
import parse from 'html-react-parser';
// import MetaTags from 'react-meta-tags';
// import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';


let isLoadData = false;
let isLoadDataDetail = false;
class ProductCoupleCombo extends Component {
    constructor(props) {
        super(props);
        isLoadData = false;
        isLoadDataDetail = false;
        this.state = {
            colorSet: '',
            sizeSet: '',
            sleeveSet: '',
            sizeFemaleSet:'',
            sleeveFemaleSet:'',
            productViewData: [],
            productWomenViewData:[],
            brand: [],
            color: [],
            size: [],
            size_female:[],
            sleeve_female:[],
            sleeve: [],
            qty: 1,
            cartCheck: false,
            removeAdd: false,
            loginModalPopup: false,
            VariableProductData: [],
            photoData: [],
            isLoader: false,
            more_desc: '',
            og_image:'',
            og_description:'',
            productname:'',
            productPrice:'',
            productSalePrice:'',
            coupleArr : [],
            gType:'man'
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    

    componentDidMount() {   
        const data = {
            product_id: this.props.match.params.id,           
        }

        this.setState({
            isLoader: true,

        }, () => {
        })
        
        isLoadData = true;
        this.props.coupleComboData(data);

    }



    componentWillReceiveProps(nextProps) {
        if (nextProps.doLoginRes && nextProps.doLoginRes.user) {
            if (nextProps.doLoginRes.user && nextProps.doLoginRes.user.LoginRes) {
                if (nextProps.doLoginRes.user.LoginRes && nextProps.doLoginRes.user.LoginRes.result === true) {
                    this.setState({
                        loginModalPopup: false
                    })

                } else {
                    this.setState({
                        loginModalPopup: false
                    })

                }
            }
        }

        if (nextProps.doRegisterRes && nextProps.doRegisterRes.user) {
            if (nextProps.doRegisterRes.user && nextProps.doRegisterRes.user.RegisterRes) {
                if (nextProps.doRegisterRes.user.RegisterRes && nextProps.doRegisterRes.user.RegisterRes.result === true) {
                    this.setState({
                        loginModalPopup: false
                    })
                } else {
                    this.setState({
                        loginModalPopup: false
                    })
                }
            }
        }

        if (nextProps.doProductCoupleComboDataRes) {
            if (nextProps.doProductCoupleComboDataRes.user && nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes) {
                if (nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.result === true && isLoadData) {
                    isLoadData = false;
                    this.setState({
                        productname: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.name,
                        productPrice: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.price,
                        productSalePrice: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.sale_price,
                        productViewData: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.data[0],
                        productWomenViewData: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.data1[0],
                        productType: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.data[0].product_type,
                        varient_product_id: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.data[0].varient_product_id,

                        varient_product_id_female: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.data1[0].varient_product_id,
                        
                        more_desc: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.more_desc,
                        og_image: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.og_image,
                        og_description: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.og_description,
                        brand: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.brand,
                        color: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.color,
                        size: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.size,
                        sleeve: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.sleeve,
                        size_female:nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.size_female,
                        sleeve_female: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.sleeve_female,
                        isLoader: false,
                    }, () => {
                        let photoItemPush = []
                        for (let photoItem of this.state.productViewData.photo) {
                            photoItemPush.push(
                                {
                                    original: photoItem.photo,
                                    thumbnail: photoItem.photo
                                }
                            )
                            this.setState({
                                photoData: photoItemPush,
                                isLoader: false
                            })
                        }
                    })
                    if (nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.color === null) {
                        this.setState({
                            color: []
                        })
                    } else {
                        if (this.state.colorSet === '') {
                            this.setState({
                                colorSet: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.data[0].color,
                            })
                        }
                    }

                    if (nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.size === null) {
                        this.setState({
                            size: []
                        })
                    } else {
                        if (this.state.sizeSet === '') {

                            this.setState({
                                sizeSet: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.data[0].size,
                            })
                        }
                    }

                    if (nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.sleeve === null) {
                        this.setState({
                            sleeve: []
                        })
                    } else {
                        if (this.state.sleeveSet === '') {
                            this.setState({
                                sleeveSet: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.data[0].sleeve,
                            })
                        }
                    }

                    if (nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.size_female === null) {
                        this.setState({
                            size_female: []
                        })
                    } else {
                        if (this.state.sizeFemaleSet === '') {
                            this.setState({
                                sizeFemaleSet: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.data1[0].size,
                            })
                        }
                    }

                    if (nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.sleeve_female === null) {
                        this.setState({
                            sleeve_female: []
                        })
                    } else {
                        if (this.state.sleeveFemaleSet === '') {

                            this.setState({
                                sleeveFemaleSet: nextProps.doProductCoupleComboDataRes.user.ProductCoupleComboRes.data1[0].sleeve,
                            })
                        }
                    }
                }
            }
        }

        if (nextProps.doAddToCartComboRes && nextProps.doAddToCartComboRes.user) {
            if (nextProps.doAddToCartComboRes.user && nextProps.doAddToCartComboRes.user.AddToCartComboRes) {
                if (nextProps.doAddToCartComboRes.user.AddToCartComboRes && nextProps.doAddToCartComboRes.user.AddToCartComboRes.result === true && this.state.removeAdd === true) {

                    this.setState({
                        cartCheck: true,
                        removeAdd: false,
                        isLoader: false
                    }, () => {
                        if (this.state.cartCheck) {
                            const cartData = {
                                user_id: localStorage.getItem('userId')
                            }
                            this.props.cartListView(cartData)
                        }
                    })
                } else {
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }

        if (nextProps.doVariableProductDetailsRes) {
            if (nextProps.doVariableProductDetailsRes.user && nextProps.doVariableProductDetailsRes.user.VariableProductDetailsRes) {
                if(nextProps.doVariableProductDetailsRes.user.VariableProductDetailsRes.result === false){
                    window.location.href = '/productcouplecombo/'+this.props.match.params.id+'/'+this.props.match.params.slug
                }
                if (nextProps.doVariableProductDetailsRes.user.VariableProductDetailsRes.result === true && isLoadDataDetail) {
                    isLoadDataDetail = false;
                    if(this.state.gType === 'man'){
                        this.setState({
                            productViewData: nextProps.doVariableProductDetailsRes.user.VariableProductDetailsRes.data[0],
                            varient_product_id: nextProps.doVariableProductDetailsRes.user.VariableProductDetailsRes.data[0].varient_product_id,
                            
                            isLoader: false,
    
                        },()=>{
                            let photoItemPush = []
                                for (let photoItem of this.state.productViewData.photo) {
                                    photoItemPush.push(
                                        {
                                            original: photoItem.photo,
                                            thumbnail: photoItem.photo
                                        }
                                    )
                                    this.setState({
                                        photoData: photoItemPush,
                                        isLoader: false
                                    })
                                }
                        })
                    }else{
                        this.setState({
                            productViewData: nextProps.doVariableProductDetailsRes.user.VariableProductDetailsRes.data[0],
                            varient_product_id_female: nextProps.doVariableProductDetailsRes.user.VariableProductDetailsRes.data[0].varient_product_id,
                            
                            isLoader: false,
    
                        },()=>{
                            let photoItemPush = []
                                for (let photoItem of this.state.productViewData.photo) {
                                    photoItemPush.push(
                                        {
                                            original: photoItem.photo,
                                            thumbnail: photoItem.photo
                                        }
                                    )
                                    this.setState({
                                        photoData: photoItemPush,
                                        isLoader: false
                                    })
                                }
                        })
                    }
                    
                } else {
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }


    }

    addtocart = (dataItem) => {
        let coupleObj = {product_id: this.state.varient_product_id, qty:this.state.qty};
        let coupelOjbFemale = {product_id: this.state.varient_product_id_female, qty:this.state.qty}
        // console.log(coupelOjbFemale)
        let coupleArr1 = [];
        coupleArr1.push(coupleObj)
        coupleArr1.push(coupelOjbFemale);
        this.setState({
            coupleArr:[...coupleArr1]
        },()=>{
            if (localStorage.getItem('userId')) {
            
                const data = {
                    user_id: localStorage.getItem('userId'),
                    product_id: dataItem.product_id,
                    product_variant_id:JSON.stringify({"data": this.state.coupleArr}),
                    // price:dataItem.sale_price,
                    qty: this.state.qty,
                    product_type: this.state.productType,
                    image_json: '',
                    text_json: '',
                    is_varient: this.props && this.props.location && this.props.location.state && this.props.location.state.is_varient ? this.props.location.state.is_varient : 1,
                    thumbnail: '',
                    thumbnail_back: '',
                    print_type: ''
                }
                this.setState({
                    removeAdd: true,
                    isLoader: true
                })
                this.props.cartToAddCombo(data)
                
    
    
            } else {
                this.getValue(true)
            }
        })
        
        

    }

    onCloseModal = () => {
        this.setState({
            loginModalPopup: false
        })
    }

    getValue = (e) => {
        this.setState({
            loginModalPopup: e
        })
    }

    handleChangeColor = (e) => {
        this.setState({
            colorSet: e.target.value,
        }, () => {
            this.variableApi();
        })
    }

    handleChangeSize = (e,t) => {
        this.setState({
            sizeSet: e.target.value,
            gType: t
        }, () => {
            this.variableApi();
        })
    }

    handleChangeSleeve = (e,t) => {
        
        this.setState({
            sleeveSet: e.target.value,
            gType:t
        }, () => {
            this.variableApi();
        })
    }

    handleFemalChangeSize =(e,t)=>{
        this.setState({
            sizeFemaleSet: e.target.value,
            gType:t
        }, () => {
            this.variableFemalApi();
        })
    }

    handleFemalChangeSleeve =(e,t)=>{
        this.setState({
            sleeveFemaleSet: e.target.value,
            gType:t
        }, () => {
            this.variableFemalApi();
        })
    }

    variableApi = () => {
        const data = {
            product_id: this.props && this.props.location && this.props.location.state && this.props.location.state.product_id,
            Tvalue: this.state.productViewData.colour_status === "True" ? this.state.colorSet : '',
            Sizvalue: this.state.productViewData.size_status === "True" ? this.state.sizeSet : '',
            SleVvalue: this.state.productViewData.sleeve_status === "True" ? this.state.sleeveSet : '',
            product_type: this.props && this.props.location && this.props.location.state && this.props.location.state.product_type,
            is_varient: this.props && this.props.location && this.props.location.state && this.props.location.state.is_varient,
        }
        this.setState({
            isLoader: true,

        }, () => {
            isLoadDataDetail = true;
            this.props.productVariable(data)
        })

    }

    variableFemalApi = () => {
        const data = {
            product_id: this.props && this.props.location && this.props.location.state && this.props.location.state.product_id,
            Tvalue: this.state.productViewData.colour_status === "True" ? this.state.colorSet : '',
            Sizvalue: this.state.productViewData.size_status === "True" ? this.state.sizeFemaleSet : '',
            SleVvalue: this.state.productViewData.sleeve_status === "True" ? this.state.sleeveFemaleSet : '',
            product_type: this.props && this.props.location && this.props.location.state && this.props.location.state.product_type,
            is_varient: this.props && this.props.location && this.props.location.state && this.props.location.state.is_varient,
        }
        this.setState({
            isLoader: true,

        }, () => {
            isLoadDataDetail = true;
            this.props.productVariable(data)
        })

    }


    render() {
        const spinner = <span><img src={loaderImg} alt="" /></span>;

        return (
            <React.Fragment>
                <LayoutWrapper />
                <Loader show={this.state.isLoader} message={spinner}>
                   
                    <main className="main main-container">
                        <nav aria-label="breadcrumb" className="breadcrumb-nav">
                            <div className="container">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={'/'}>Home</Link></li>
                                    {/* {this.state.productViewData && this.state.productViewData.map((item,i) =>( */}
                                    <li className="breadcrumb-item"><Link to={'#'}>{this.state.productname}</Link></li>
                                    {/* ))} */}

                                </ol>
                            </div>
                            {/* End .container */}
                        </nav>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="product-single-container product-single-default">
                                        {/* {this.state.productViewData && this.state.productViewData.map((item,i) =>( */}
                                        <div className="row" >
                                            <div className="col-lg-5 col-md-6">
                                                <ImageGallery showPlayButton={false} items={this.state.photoData} />

                                            </div>
                                            {/* End .col-lg-7 */}

                                            <div className="col-lg-7 col-md-6">
                                                <div className="product-single-details">
                                                    <h1 className="product-title font-capital">
                                                        {this.state.productname}
                                                    </h1>
                                                    {/* End .product-container */}

                                                    <div className="price-box">
                                                        <span className="old-price">
                                                            <i className="fa fa-rupee-sign " aria-hidden="true"></i>
                                                            {this.state.productPrice}.00
                                                        </span>
                                                        <span className="product-price color-price">
                                                            <i className="fa fa-rupee-sign" aria-hidden="true"></i>
                                                            {this.state.productSalePrice}.00
                                                        </span>
                                                    </div>
                                                    {/* End .price-box */}

                                                    {/* <div className="product-desc">
                                                        <p>{item.description}</p>
                                                    </div> */}
                                                    {/* End .product-desc */}

                                                    {/* Product Option Select Start*/}

                                                    <table className="variations table-width" cellSpacing="0">
                                                        <tbody>
                                                            {
                                                                this.state.productViewData && this.state.productViewData.colour_status === "True" &&
                                                                <tr>
                                                                    <td className="label ">
                                                                        <label htmlFor="pa_color" className="col-md-3">Color</label>
                                                                    </td>
                                                                    <td className="value">
                                                                        <select className="col-md-12 variationsSelect" name="attribute_pa_color" data-attribute_name="attribute_pa_color" data-show_option_none="yes" onChange={this.handleChangeColor} value={this.state.colorSet}>

                                                                            {this.state.color && this.state.color.map((item, i) => (
                                                                                <option  value={item.name} className="attached enabled" key={i}>{item.name}</option>
                                                                            ))}

                                                                        </select>
                                                                    </td>
                                                                </tr>
                                                            }
                                                            <tr>
                                                                <td className="label">
                                                                    <label htmlFor="pa_size" className="col-md-4"></label>
                                                                </td>
                                                                <td className="label">
                                                                    <label htmlFor="pa_size" className="col-md-4">Size</label>
                                                                </td>
                                                                <td className="label">
                                                                    <label htmlFor="pa_size" className="col-md-4">Sleeve</label>
                                                                </td>
                                                            </tr>
                                                            {
                                                                this.state.productViewData && this.state.productViewData.size_status === "True" &&
                                                                <tr>
                                                                    <td className="label">
                                                                        <label htmlFor="pa_size" className="col-md-8">Men</label>
                                                                    </td>
                                                                    <td className="value">
                                                                        <select id="pa_size" className="col-md-8 variationsSelect" name="attribute_pa_size" data-attribute_name="attribute_pa_size" data-show_option_none="yes" onChange={(e) => this.handleChangeSize(e,'man')}
                                                                            value={this.state.sizeSet}>

                                                                            {
                                                                                this.state.size && this.state.size.map((item, i) => (
                                                                                    <option value={item.name} className="attached enabled" key={i}>{item.name}
                                                                                    </option>
                                                                                ))
                                                                            }

                                                                        </select>
                                                                    </td>
                                                                    <td className="value">
                                                                        <select id="pa_sleeve" className="col-md-8 variationsSelect" name="attribute_pa_sleeve" data-attribute_name="attribute_pa_sleeve" data-show_option_none="yes" onChange={(e)=>this.handleChangeSleeve(e,'man')} value={this.state.sleeveSet}>

                                                                            {this.state.sleeve && this.state.sleeve.map((item, i) => (<option  value={item.name} className="attached enabled" key={i}>{item.name}</option>))}

                                                                        </select>

                                                                    </td>
                                                                </tr>
                                                            }

                                                            {
                                                                this.state.productViewData && this.state.productViewData.sleeve_status === "True" &&
                                                                <tr>
                                                                    <td className="label"><label htmlFor="pa_sleeve" className="col-md-8">Women</label></td>
                                                                    <td className="value">
                                                                        <select id="pa_size" className="col-md-8 variationsSelect" name="attribute_pa_size" data-attribute_name="attribute_pa_size" data-show_option_none="yes" onChange={(e)=>this.handleFemalChangeSize(e, 'women')}
                                                                            value={this.state.sizeFemaleSet}>

                                                                            {
                                                                                this.state.size_female && this.state.size_female.map((item, i) => (
                                                                                    <option value={item.name} className="attached enabled" key={i}>{item.name}
                                                                                    </option>
                                                                                ))
                                                                            }

                                                                        </select>
                                                                    </td>
                                                                    <td className="value">
                                                                        <select id="pa_sleeve" className="col-md-8 variationsSelect" name="attribute_pa_sleeve" data-attribute_name="attribute_pa_sleeve" data-show_option_none="yes" onChange={(e)=>this.handleFemalChangeSleeve(e,'women')} value={this.state.sleeveFemaleSet}>

                                                                            {this.state.sleeve_female && this.state.sleeve_female.map((item, i) => (<option  value={item.name} className="attached enabled" key={i}>{item.name}</option>))}

                                                                        </select>

                                                                    </td>
                                                                </tr>
                                                            }


                                                        </tbody>
                                                    </table>
                                                    {/* Product Option Select End*/}
                                                    {/* End .product-filters-container */}

                                                    <div className="product-action product-all-icons">
                                                        <div className="product-single-qty" style={{ "display": "flex" }}>
                                                            <button className="btn btn-outline" disabled={this.state.qty === 1} onClick={() => this.setState({ qty: this.state.qty - 1 })}>-</button>

                                                            <input className="horizontal-quantity form-control" type="text" onChange={(e) => parseInt(e.target.value) > 1 ? this.setState({ qty: e.target.value < 20 ? parseInt(e.target.value) : 20 }) : ''} value={this.state.qty} placeholder='qty'/>

                                                            <button className="btn btn-outline" onClick={() => this.setState({ qty: this.state.qty < 20? this.state.qty+1:this.state.qty})}>+</button>
                                                        </div>
                                                        {/* End .product-single-qty */}

                                                        <div className="paction add-cart show-color detais-btn pointer" title="Add to Cart" onClick={() => this.addtocart(this.state.productViewData)}>
                                                            <span>Add to Cart</span>
                                                        </div>
                                                    </div>
                                                    {/* End .product-action */}

                                                    <div className="product-single-share">
                                                        {/* <label>Share:</label> */}

                                                        {/* www.addthis.com share plugin */}
                                                        {/* <div className="addthis_inline_share_toolbox"></div> */}
                                                    </div>
                                                    {/* End .product single-share */}
                                                </div>
                                                {/* End .product-single-details */}
                                            </div>
                                            {/* End .col-lg-5 */}
                                        </div>

                                        {/* ))} */}

                                        {/* End .rows */}
                                    </div>
                                    {/* End .product-single-container */}

                                    <div className="product-single-tabs">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item">
                                                <a className="description-a" id="product-tab-desc" data-toggle="tab" href="product.html#product-desc-content" role="tab" aria-controls="product-desc-content" aria-selected="true">Description</a>
                                            </li>

                                        </ul>
                                        <div className="tab-content">
                                            {/* {this.state.productViewData && this.state.productViewData.map((item,i) =>( */}
                                            <div className="tab-pane fade show active" id="product-desc-content" role="tabpanel" aria-labelledby="product-tab-desc">
                                                <div className="product-desc-content">
                                                    <div>{parse('' + this.state.more_desc + '')}</div>
                                                    <div>
                                                        <h4>
                                                            For Bulk Order 
                                                            <Link to="/contacts"        className="link-transform">
                                                                &nbsp;Contact Us
                                                            </Link>
                                                        </h4>
                                                    </div>
                                                </div>
                                                {/* End .product-desc-content */}
                                            </div>
                                            {/*  ))} */}

                                            {/* End .tab-pane */}



                                        </div>
                                        {/* End .tab-content */}
                                    </div>
                                    {/* End .product-single-tabs */}
                                </div>
                                {/* End .col-md-3 */}
                            </div>
                            {/* End .row */}
                        </div>
                        {/* End .container */}


                    </main>
                </Loader>
                {/* End .main */}
                <Modal open={this.state.loginModalPopup} onClose={this.onCloseModal} >
                    <LoginRegister getValue={this.getValue} />
                </Modal>

                <Footer />
            </React.Fragment>
        )
    }
}

ProductCoupleCombo.propTypes = {
    doProductCoupleComboDataRes: PropTypes.any,
    doAddToCartComboRes: PropTypes.any,
    doCartListRes: PropTypes.any,
    doLoginRes: PropTypes.any,
    doRegisterRes: PropTypes.any,
    doVariableProductDetailsRes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
    doProductCoupleComboDataRes: doProductCoupleComboDataRes,
    doAddToCartComboRes: doAddToCartComboRes,
    doCartListRes: doCartListRes,
    doLoginRes: doLoginRes,
    doRegisterRes: doRegisterRes,
    doVariableProductDetailsRes: doVariableProductDetailsRes,
});

function mapDispatchToProps(dispatch) {
    return {
        coupleComboData: (data) => dispatch(coupleComboData(data)),
        cartToAddCombo: (data) => dispatch(cartToAddCombo(data)),
        cartListView: (data) => dispatch(cartListView(data)),
        login_list: (data) => dispatch(login_list(data)),
        createRegister: (data) => dispatch(createRegister(data)),
        productVariable: (data) => dispatch(productVariable(data)),
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(ProductCoupleCombo)